"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _keyname = _interopRequireDefault(require("keyname"));

var _rndid = _interopRequireDefault(require("../../utils/rndid"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Select =
/*#__PURE__*/
function (_Component) {
  _inherits(Select, _Component);

  function Select() {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this));

    _defineProperty(_assertThisInitialized(_this), "state", {
      expanded: false
    });

    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    _this.focusSelect = _this.focusSelect.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          value = _this$props.value,
          options = _this$props.options;

      if (!value) {
        return;
      }

      this.updateValue(options, value);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          value = _this$props2.value,
          options = _this$props2.options,
          onSelect = _this$props2.onSelect;

      if (value !== prevProps.value) {
        this.updateValue(options, value, onSelect);
      }
    }
  }, {
    key: "updateValue",
    value: function updateValue(options, value, onSelect) {
      var activeIndex = options.findIndex(function (o) {
        return o.value === value;
      });

      if (activeIndex === -1) {
        return;
      }

      this.setState({
        activeIndex: activeIndex,
        selectedIndex: activeIndex
      });

      if (onSelect) {
        onSelect(options[activeIndex]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          expanded = _this$state.expanded,
          activeIndex = _this$state.activeIndex,
          selectedIndex = _this$state.selectedIndex;

      var _this$props3 = this.props,
          className = _this$props3.className,
          label = _this$props3.label,
          required = _this$props3.required,
          selectedId = _this$props3.selectedId,
          listId = _this$props3.listId,
          options = _this$props3.options,
          onSelect = _this$props3.onSelect,
          other = _objectWithoutProperties(_this$props3, ["className", "label", "required", "selectedId", "listId", "options", "onSelect"]);

      var hasActiveOption = typeof activeIndex !== 'undefined';
      var active = options[activeIndex];
      var pseudoVal = hasActiveOption && active && (active.label || active.value);
      var labelId = (0, _rndid["default"])();
      var valueId = (0, _rndid["default"])();
      var opts = options.map(function (option, i) {
        var value = option.value,
            label = option.label,
            disabled = option.disabled; // we don't need key events here because focus stays on the combobox element

        /* eslint-disable jsx-a11y/click-events-have-key-events */

        return _react["default"].createElement("li", {
          key: "".concat(selectedId, "-").concat(i),
          className: (0, _classnames["default"])('dqpl-option', {
            'dqpl-option-active': hasActiveOption ? activeIndex === i : i === 0
          }),
          role: "option",
          "aria-selected": selectedIndex === i,
          "aria-disabled": disabled,
          id: activeIndex === i ? selectedId : undefined,
          onClick: function onClick() {
            if (disabled) {
              return;
            }

            _this2.setState({
              activeIndex: i,
              selectedIndex: i,
              expanded: false
            });

            onSelect(option);

            _this2.focusSelect();
          }
        }, label || value);
      }); // to make the "dqpl-label" div behave like a native label,
      // here we add a click listener which focuses the combobox

      /* eslint-disable jsx-a11y/no-static-element-interactions */

      return _react["default"].createElement("div", {
        className: "dqpl-field-wrap"
      }, _react["default"].createElement("div", {
        className: "dqpl-label",
        id: labelId,
        onClick: this.focusSelect
      }, label), _react["default"].createElement("div", {
        className: "dqpl-select"
      }, _react["default"].createElement("div", _extends({}, other, {
        className: (0, _classnames["default"])('dqpl-combobox', className),
        tabIndex: 0,
        role: "combobox",
        "aria-autocomplete": "none",
        "aria-expanded": expanded,
        "aria-required": required,
        "aria-labelledby": "".concat(labelId, " ").concat(valueId),
        "aria-controls": listId,
        "aria-activedescendant": hasActiveOption ? selectedId : '',
        onKeyDown: this.onKeyDown,
        onClick: this.onClick,
        ref: function ref(select) {
          return _this2.select = select;
        }
      }), _react["default"].createElement("div", {
        role: "textbox",
        "aria-readonly": true,
        className: "dqpl-pseudo-value",
        id: valueId
      }, pseudoVal)), _react["default"].createElement("ul", {
        id: listId,
        role: "listbox",
        className: (0, _classnames["default"])('dqpl-listbox', {
          'dqpl-listbox-show': expanded
        })
      }, opts)));
      /* eslint-enable jsx-a11y/click-events-have-key-events jsx-a11y/no-static-element-interactions */
    }
  }, {
    key: "findAdjacentEnabledOption",
    value: function findAdjacentEnabledOption(dir) {
      var options = this.props.options;
      var _this$state$activeInd = this.state.activeIndex,
          activeIndex = _this$state$activeInd === void 0 ? 0 : _this$state$activeInd;
      var d = dir === 'up' ? -1 : 1;
      var adjacentIndex,
          i = activeIndex + d;

      while (options[i] && typeof adjacentIndex === 'undefined') {
        if (!options[i].disabled) {
          adjacentIndex = i;
        }

        i += d;
      }

      return adjacentIndex;
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var options = this.props.options;
      var _this$state2 = this.state,
          expanded = _this$state2.expanded,
          activeIndex = _this$state2.activeIndex;
      var onSelect = this.props.onSelect;
      var which = e.which;
      var key = (0, _keyname["default"])(which);

      switch (key) {
        case 'down':
          {
            e.preventDefault();
            var prev = expanded && this.findAdjacentEnabledOption('down');

            if (!expanded) {
              this.setState({
                expanded: true
              });
            } else if (typeof prev !== 'undefined') {
              this.setState({
                activeIndex: prev
              });
            }

            break;
          }

        case 'up':
          {
            if (!expanded) {
              return;
            }

            e.preventDefault();
            var next = this.findAdjacentEnabledOption('up');

            if (typeof next !== 'undefined') {
              this.setState({
                activeIndex: next
              });
            }

            break;
          }

        case 'esc':
        case 'tab':
          if (expanded) {
            this.onClose();
          }

          break;

        case 'enter':
        case 'space':
          e.preventDefault();

          if (expanded) {
            this.setState({
              selectedIndex: activeIndex,
              expanded: false
            });
            onSelect(options[activeIndex]);
          } else if (key === 'space') {
            this.onClick();
          }

          break;

        default:
          // for letters/numbers, jump to the first matching option (like native <select />s)
          if (expanded && (0, _utils.shouldSearch)(which)) {
            var jumpTo = (0, _utils.search)(key, options);

            if (jumpTo >= 0 && jumpTo !== activeIndex) {
              this.setState({
                activeIndex: jumpTo
              });
            }
          }

      }

      this.props.onKeyDown(e);
    }
  }, {
    key: "onClick",
    value: function onClick() {
      this.setState({
        expanded: !this.state.expanded
      });
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.setState({
        expanded: false,
        activeIndex: this.state.selectedIndex
      });
    }
  }, {
    key: "focusSelect",
    value: function focusSelect() {
      this.select.focus();
    }
  }]);

  return Select;
}(_react.Component);

exports["default"] = Select;

_defineProperty(Select, "propTypes", {
  // ensure options is an array of objects with at least a "value" property
  options: _propTypes["default"].arrayOf(function (options, key, componentName, location, propFullName) {
    var option = options[key];

    if (!option.value) {
      return new Error("Invalid prop ".concat(propFullName, " supplied to ").concat(componentName));
    }
  }).isRequired,
  label: _propTypes["default"].string.isRequired,
  listId: _propTypes["default"].string.isRequired,
  selectedId: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  onKeyDown: _propTypes["default"].func,
  required: _propTypes["default"].bool,
  onSelect: _propTypes["default"].func,
  value: _propTypes["default"].string
});

_defineProperty(Select, "defaultProps", {
  className: '',
  required: false,
  onKeyDown: function onKeyDown() {},
  onSelect: function onSelect() {},
  value: null
});